module.exports = __webpack_public_path__ + "img/1f454.9644f34.svg";